module.exports = __webpack_public_path__ + "img/ERUPCION_MAL_ESTADO.png";